import React, { Component } from 'react';
import { Col, Container, Row, Button, Card, CardBody, ButtonToolbar, Input } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import * as myConstClass from '../../../constant.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Field, reduxForm } from 'redux-form';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

class Banner_add extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      submitted: false,
      errors: {},
    }
  }

  componentDidMount() {
    if (!localStorage.getItem('session_id')) {
      this.props.history.push('/log_in');
    }
  }

  handleChange = (event) => {
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    this.setState({ formData });
  }

  handleSubmit = () => {
    let form = document.querySelector('#pform');
    const errors = {};
    const formData = new FormData(form);

    this.setState({ submitted: true }, () => {
      if (localStorage.getItem('uid')) {
        formData.append('user_id', localStorage.getItem('uid'));
      }

      setTimeout(() => this.setState({ submitted: false }), 5000);
      fetch(myConstClass.BASE_URL + `/banner/AddBanner`, {
        method: 'POST',
        body: formData,
      }).then(response => response.json()).then((response) => {
        if (response == true) {
          this.props.history.push('/forms/banner/');
          toast('Banner Added Successfully..!', { containerId: 'B', type: toast.TYPE.SUCCESS })
        } else {
          toast('Banner Insertion Failed..!', { containerId: 'B', type: toast.TYPE.ERROR })
        }
      }).catch();
    });
  }

  onImageFileChange = event => {
    const errors = {};
    const size = (event.target.files[0].size / 1024).toFixed(2);
    const fsize = (event.target.files[0].size).toFixed(2);
    const current_file_size = Math.round((fsize / 1024));
    if (current_file_size > 5120) {
      alert("The file must be less than 5 mb");
      toast('The file must be less than 5 mb', { containerId: 'B', type: toast.TYPE.ERROR })
      errors["image_error"] = "The file must be less than 5 mb";
    } else {
      errors["image_error"] = "";
    }
    this.setState({ selectedImage: event.target.files[0] });
    this.setState({ errors: errors });
  };

  render() {
    const { formData, submitted } = this.state;
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Add Banner</h3>
          </Col>
        </Row>
        <Row>
          <Card>
            <CardBody>
              <div className="card__title">
              </div>
              <div>
                <ToastContainer enableMultiContainer containerId={'A'} position={toast.POSITION.BOTTOM_LEFT} />
                <ToastContainer enableMultiContainer containerId={'B'} position={toast.POSITION.TOP_RIGHT} />
              </div>
              <ValidatorForm
                className="material-form" id="pform"
                onSubmit={this.handleSubmit}
              >
                <Row>
                  <Col md={6} lg={6}>
                    <TextValidator
                      onChange={this.handleChange}
                      name="title"
                      label="Title"
                      value={formData.title}
                      validators={['required']}
                      errorMessages={['this field is required']}
                      className="material-form__field"
                    />
                    <div>
                    </div>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={6} lg={6}>
                    <TextValidator
                      onChange={this.handleChange}
                      name="redirection_url"
                      label="Redirection url"
                      value={formData.redirection_url}
                      validators={['required']}
                      errorMessages={['this field is required']}
                      className="material-form__field"
                    />
                    <div>
                    </div>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={6} lg={6}>
                    <h6>Select Image</h6>
                    <input type="file"
                      // onChange={this.handleChange}
                      onChange={this.onImageFileChange}
                      name="image"
                      value={formData.image}
                    />
                    <br />
                    <span className="">
                      (Note: The file must be less than 5 mb)
                    </span>
                    <br />
                    <span className="red-text">
                      {this.state.errors["image_error"]}
                    </span>
                    <div>
                    </div>
                  </Col>
                </Row>
                <br />
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  disabled={submitted}
                >
                  {(submitted && 'Your form is submitted!') || (!submitted && 'Submit')}
                </Button>
              </ValidatorForm>
            </CardBody>
          </Card>
        </Row>
      </Container>
    )
  }
}

export default reduxForm({
  form: 'floating_labels_form', // a unique identifier for this form
})(withTranslation('common')(Banner_add));
